import { numberFormatterWithDecimalAndThousand } from "src/helper/numberFormatterWithDecimalAndThousand"

const isPaymenOnline = (detail) => {
  //ex: CARD, UATP
  try {
    return detail?.ref_table_detail == 'payment_online'
  } catch (error) {
    return false
  }
}

const isCardNumber = (field) => {
  try {
    return field == 'card_number'
  } catch (error) {
    return false
  }
}

const isAmount = (field) => {
  try {
    return field == 'amount_used' || field == 'amount'
  } catch (error) {
    return false
  }
}

const hasX = (str) => {
  try {
    return str.toUpperCase().includes('X')
  } catch (error) {
    return str
  }
}

const encripValue = (value) => {
  try {
    if (value.length > 10) {
      return `${value.slice(0, 6)}XXXXXX${value.slice(-4)}`
    } else {
      // Si la longitud es menor o igual a 10, enmascarar los últimos 4 caracteres
      const visibleLength = value.length - 4
      return `${value.slice(0, visibleLength)}${'X'.repeat(4)}`
    }
  } catch (error) {
    return value
  }
}

export const getField = (key, detail, field, translate) => {
  const fieldSplit = field.split('.')
  let value = detail
  fieldSplit.forEach((elem) => {
    value = value?.[elem]
  })

  if (field.includes('date') && value) {
    value = new Date(value)
    if (!isNaN(value)) {
      if (isPaymenOnline(detail)) {
        // Formatea la fecha en el formato "mm/yy"
        const month = value.getUTCMonth() + 1 // getUTCMonth() es 0-indexado
        const year = value.getUTCFullYear()
        value = `${month}/${year}`
      } else {
        value = value.toLocaleDateString()
      }
    } else {
      value = ''
    }
  }

  if (isCardNumber(field)) {
    if (!hasX(value)) {
      value = encripValue(value)
    }
  }

  if (isAmount(field)) {
    value = numberFormatterWithDecimalAndThousand(value)
  }
  if (value) {
    return (
      <div key={key} style={{ display: 'flex', flexDirection: 'column' }} className='field'>
        <b>{translate(`ra.field.${fieldSplit[fieldSplit.length - 1]}`)}</b>
        <span>{value}</span>
      </div>
    )
  }
}
